<template>

    <Toast />

    <MenuSiModuleAffiliate />

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Invoices</h3>

                    <DataTable :value="invoices" :paginator="true" class="p-datatable-gridlines" :rows="100"
                        dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true" :striped-rows="true"
                        :reorderableColumns="true" v-model:filters="filters" filterDisplay="menu" :loading="loading"
                        :filters="filters" responsiveLayout="scroll"
                        :globalFilterFields="['uniqueId', 'invoiced', 'clientName']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                            optionLabel="header" @update:modelValue="onToggleColumns" display="chip"
                                            placeholder="Select Columns" />
                                    </div>

                                    <div class="col-12 lg:col-3 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                            class="p-button-outlined p-ml-2" @click="clearFilter()" />
                                    </div>
                                    <div class="col-12 lg:col-3 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                            class="p-button-outlined" @click="restoreToOriginal()" />
                                    </div>

                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filters['global'].value"
                                            placeholder="Keyword Search on Invoice ID, Invoice Date or Client"
                                            style="width: 100%" />
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>
                            No invoices found.
                        </template>

                        <template #loading>
                            Loading invoices. Please wait.
                        </template>

                        <Column field="uniqueId" header="Invoice #" :sortable="true" />
                        <Column field="invoiced" header="Invoiced" :sortable="true" />

                        <template v-for="col in selectedColumns" :key="col.field">

                            <Column v-if="col.field === 'amount'" :field="col.field" :header="col.header"
                                :sortable="col.sortable">
                                <template #body="{ data }">
                                    <span class="p-column-title">Amount</span>
                                    {{ formatAmount(data.amount) }}
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'paid'" :field="col.field" :header="col.header"
                                :sortable="col.sortable">
                                <template #body="{ data }">
                                    <span class="p-column-title">Amount</span>
                                    {{ formatAmount(data.paid) }}
                                </template>
                            </Column>

                            <Column v-else :field="col.field" :header="col.header" :sortable="col.sortable" />


                        </template>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                    :class="'status-badge status-' + data.status">Unpaid</span>
                                <span v-if="data.status === 'S'"
                                    :class="'status-badge status-' + data.status">Submitted</span>
                                <span v-if="data.status === 'P'"
                                    :class="'status-badge status-' + data.status">Paid</span>
                                <span v-if="data.status === 'U'" :class="'status-badge status-' + data.status">Unpaids
                                    Process</span>
                                <span v-if="data.status === 'C'"
                                    :class="'status-badge status-' + data.status">Archived</span>
                                <span v-if="data.status === 'M'" :class="'status-badge status-' + data.status">Member
                                    Liable</span>
                            </template>
                        </Column>

                    </DataTable>


                </div>
            </div>
        </div>

    </div>


    <IsoEvolveFooter />

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import { useUserStore } from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import StockDataService from "@/service/StockDataService";
import StockHistoryService from "@/service/StockHistoryService";
import InvoiceService from "@/service/InvoiceService";
import ClientService from "@/service/ClientService";
import { right } from "core-js/internals/array-reduce";
import MenuSiModuleAffiliate from "@/components/menu/simodule/MenuSiModuleAffiliate.vue";

export default {
    components: {
        MenuSiModuleAffiliate,
        IsoEvolveFooter,
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

    },
    async mounted() {
        // const documentStyle = getComputedStyle(document.documentElement);
        // const textColor = documentStyle.getPropertyValue('--text-color');
        // const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        // const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        //
        // console.log("[Overview][mounted] documentStyle = ", documentStyle);
        // console.log("[Overview][mounted] textColor = ", textColor);
        // console.log("[Overview][mounted] textColorSecondary = ", textColorSecondary);
        // console.log("[Overview][mounted] surfaceBorder = ", surfaceBorder);

        // this.lineData.value = {
        //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        //     datasets: [
        //         {
        //             label: 'First Dataset',
        //             data: [65, 59, 80, 81, 56, 55, 40],
        //             fill: false,
        //             backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-500'),
        //             borderColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-500'),
        //             tension: 0.4
        //         },
        //         {
        //             label: 'Second Dataset',
        //             data: [28, 48, 40, 19, 86, 27, 90],
        //             fill: false,
        //             backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--text-color-secondary'),
        //             borderColor: getComputedStyle(document.documentElement).getPropertyValue('--surface-border'),
        //             tension: 0.4
        //         }
        //     ]
        // };
        //
        // this.lineOptions.value = {
        //     plugins: {
        //         legend: {
        //             labels: {
        //                 fontColor: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
        //             }
        //         }
        //     },
        //     scales: {
        //         x: {
        //             ticks: {
        //                 color: getComputedStyle(document.documentElement).getPropertyValue('--text-color-secondary')
        //             },
        //             grid: {
        //                 color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border'),
        //                 drawBorder: false
        //             }
        //         },
        //         y: {
        //             ticks: {
        //                 color: getComputedStyle(document.documentElement).getPropertyValue('--text-color-secondary')
        //             },
        //             grid: {
        //                 color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border'),
        //                 drawBorder: false
        //             }
        //         }
        //     }
        // };

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[AppointmentsNew][mounted] Data = ", userData);
            console.log("[AppointmentsNew][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        const [clientData] = await Promise.all([
            ClientService.getClientForUser(this.userStore.user.id),
        ]);

        this.client = clientData.data;
        console.log("[AppointmentsNew][mounted] clientData.data = ", clientData.data);

        const invoicesData = await InvoiceService.getCompanyAffiliateInvoices(this.profile.companyId, this.client.id);

        this.invoices = invoicesData.data;
        this.originalInvoices = invoicesData.data;

        this.loading = false;

        this.columnsDefault = [
            { field: 'clientName', header: 'Client Name', sortable: true },
            { field: 'amount', header: 'Amount', sortable: true },
            { field: 'paid', header: 'Paid', sortable: true },
        ];

        this.columnsFullList = [
            { field: 'clientName', header: 'Client Name', sortable: true },
            { field: 'amount', header: 'Amount', sortable: true },
            { field: 'paid', header: 'Paid', sortable: true },
        ];

        this.selectedColumns = this.columnsDefault;

        const [clientConfigData] = await Promise.all([
            ClientService.getClientConfiguration(this.client.id)
        ]);

        this.clientConfiguration = clientConfigData.data;
        console.log("[AppointmentsNew][mounted] userConfigData.data = ", clientConfigData.data);

        this.loading = false;

        console.log("[AppointmentsNew][mounted] this.client = ", this.client);
        console.log("[AppointmentsNew][mounted] this.clientConfiguration = ", this.clientConfiguration);
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            client: {},
            clientConfiguration: {},
            filters: null,
            loading: true,
            searching: false,
            customUrl: null,
            commission: null,
            commissionRecurringOption: null,
            commissionTax: null,
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            invoices: null,
        }
    },
    computed: {
        formattedCurrentDividendYieldId050: {
            get() {
                return this.formatAmount(this.stockData.currentDividendYieldId050);
            },
            set(newValue) {
                // Define how to parse the formatted value back to the original format
                // This is just an example and might need more robust implementation
                this.stockData.currentDividendYieldId050 = parseFloat(newValue.replace(/[^0-9.-]+/g, ""));
            }
        },
        formattedBookValuePerShare: {
            get() {
                return this.formatAmount(this.stockData.bookValuePerShare);
            },
            set(newValue) {
                // Define how to parse the formatted value back to the original format
                // This is just an example and might need more robust implementation
                this.stockData.bookValuePerShare = parseFloat(newValue.replace(/[^0-9.-]+/g, ""));
            }
        }
    },
    methods: {
        right,
        initFilters() {
            this.filters = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'codeId129': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
                },
                'companyNameId046': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {

            if (this.searching) {
                this.activeTab = 5;
            } else {
                this.activeTab = 1;
            }
        },
        callResetSearchResults() {
            this.searching = false;
            this.activeTab = 1;
        },
        callTrack() {
            window.location.href = "/#/siTrack";
        },
        callAchieve() {
            window.location.href = "/#/siAchieve";
        },
        callColumnDefinitions() {
            this.activeTab = 2;
        },
        async callBasicSearch() {
            console.log("[callBasicSearch] this.searchCriteria = ", this.searchCriteria);
            console.log("[callBasicSearch] this.selectedExchange = ", this.selectedExchange);
            this.searching = true;

            if (this.searchCriteria.trim() === '') {
                this.activeTab = 1;
            } else {
                const [stockDataInfo] = await Promise.all([
                    StockDataService.searchStockDataForExchange(this.selectedExchange, 'S', this.searchCriteria.trim())
                ]);

                this.searchStockData = stockDataInfo.data;
                console.log("[callBasicSearch] this.searchStockData = ", this.searchStockData);

                this.activeTab = 5;
                this.selectedFormat = "Compact";
            }

            // if (this.searchCriteria.trim() === '') {
            //     this.activeTab = 1;
            // } else if (this.searchCriteria.trim() !== '' && !this.searchCriteria.includes(',')) {
            //     this.activeTab = 5;
            //
            //     try {
            //         const [stockDataInfo] = await Promise.all([
            //             StockDataService.getSpecificStockDataForExchangeAndCode(this.selectedExchange, this.searchCriteria)
            //         ]);
            //
            //         this.specificStockData = stockDataInfo.data;
            //
            //         console.log("[callBasicSearch] this.specificStockData = ", this.specificStockData);
            //
            //     } catch (e) {
            //         console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);
            //         this.activeTab = 7;
            //     }
            //
            // } else {
            //     this.activeTab = 6;
            // }

            this.searchCriteria = '';
        },
        callAdvancedSearch() {
            this.activeTab = 3;
            this.advancedSearchStockData.siCriteriaYear5Id125 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear5Id132 = null;
            this.advancedSearchStockData.siCriteriaYear10Id126 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear10Id133 = null;
            this.advancedSearchStockData.siCriteriaYear15Id127 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear15Id134 = null;
            this.advancedSearchStockData.siCriteriaYear20Id128 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear20Id135 = null;
            this.advancedSearchStockData.exchangeId073 = null;
            this.advancedSearchStockData.sectorId121 = null;
            this.advancedSearchStockData.industryId081 = null;
            this.advancedSearchStockData.yearsDividendIncreasesId047 = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesInput = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesOption = null;
        },
        callManageFilters() {
            this.activeTab = 6;
        },
        callToOverview() {
            this.activeTab = 1;
        },
        async onCompanyCodeClick(inputStockData) {
            // handle the click event here, for example, navigate or display details
            console.log("Company clicked:", inputStockData);
            console.log("inputStockData.code = ", inputStockData.code);

            this.activeTab = 4;
            this.specificStockData = inputStockData;
            this.specificStockDataArray = [inputStockData];

            try {
                const [stockHistoryInfo] = await Promise.all([
                    StockHistoryService.getStockHistory(this.selectedExchange, inputStockData.codeId129)
                ]);

                this.stockHistory = stockHistoryInfo.data;
                console.log("[AppointmentsNew][mounted] this.stockHistory = ", this.stockHistory);

                const sliceSize = -25;
                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);
                this.stockHistory = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;


            } catch (e) {
                console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);
            }

            const sliceSize = -20;

            const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

            const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

            console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

            let selectedOption = "dividendPerShare";
            let selectedLabel = "Dividends Per Share";

            this.lineData = {
                labels: recentYears.map(item => item.year),
                datasets: [
                    {
                        label: selectedLabel, // Use the name from the selected option
                        data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                        fill: false,
                        borderColor: '#42A5F5',
                        tension: 0.4
                    }
                ]
            };

            this.lineOptions = {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top'
                    }
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Months'
                        }
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Value'
                        }
                    }
                }
            };

            console.log("this.specificStockData = ", this.specificStockData);
        },
        getDividendTrap() {
            let averageDividendYieldTotal = 0;

            let combinedList = [];
            let topRankedList = [];
            let runnersUpList = [];

            if (this.selectedExchange === "JSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria);
            } else if (this.selectedExchange === "LSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
            } else {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
            }

            // Combine both lists into one
            combinedList = [...topRankedList, ...runnersUpList];

            console.log("[getDividendTrap] this.selectedExchange:", this.selectedExchange);
            console.log("[getDividendTrap] topRankedList:", topRankedList);
            console.log("[getDividendTrap] runnersUpList:", runnersUpList);
            console.log("[getDividendTrap] combinedList:", combinedList);

            // Calculate the total dividend yield
            let totalDividendYield = combinedList.reduce((total, stock) => {
                return total + (stock.currentDividendYieldId050 || 0);
            }, 0);

            // Calculate average dividend yield (if topRankedList is not empty)
            if (combinedList.length > 0) {
                averageDividendYieldTotal = totalDividendYield / combinedList.length;
            }

            // Store the calculated average dividend yield total
            this.averageDividendYield = averageDividendYieldTotal;
            this.maxDividendYield = this.averageDividendYield * 2.5;

            console.log("[getDividendTrap] totalDividendYield = ", totalDividendYield);
            console.log("[getDividendTrap] combinedList.length = ", combinedList.length);
            console.log("[getDividendTrap] this.averageDividendYield = ", this.averageDividendYield);
            console.log("[getDividendTrap] this.maxDividendYield = ", this.maxDividendYield);

        },
        getStockCounts() {
            let topRankedCount = 0;
            let runnersUpCount = 0;
            let dividendUnderValuedCount = 0;
            let dividendOverValuedCount = 0;
            let dividendDeepValuedCount = 0;
            let nondividendUnderValuedCount = 0;
            let nondividendOverValuedCount = 0;
            let nondividendDeepValuedCount = 0;

            if (this.selectedTimePeriod === "5") {
                dividendUnderValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear5Id132 === 'U'
                ).length;

                dividendOverValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear5Id132 === 'O'
                ).length;

                dividendDeepValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear5Id053) >= 200)
                ).length;

                nondividendUnderValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear5Id132 === 'U'
                ).length;

                nondividendOverValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear5Id132 === 'O'
                ).length;

                nondividendDeepValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear5Id057) <= 90)
                ).length;

            } else if (this.selectedTimePeriod === "10") {
                dividendUnderValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear10Id133 === 'U'
                ).length;

                dividendOverValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear10Id133 === 'O'
                ).length;

                dividendDeepValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear10Id054) >= 200)
                ).length;

                nondividendUnderValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear10Id133 === 'U'
                ).length;

                nondividendOverValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear10Id133 === 'O'
                ).length;

                nondividendDeepValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear10Id058) <= 90)
                ).length;

            } else if (this.selectedTimePeriod === "15") {
                dividendUnderValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear15Id134 === 'U'
                ).length;

                dividendOverValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear15Id134 === 'O'
                ).length;

                dividendDeepValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear15Id055) >= 200)
                ).length;

                nondividendUnderValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear15Id134 === 'U'
                ).length;

                nondividendOverValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear15Id134 === 'O'
                ).length;

                nondividendDeepValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear15Id059) <= 90)
                ).length;

            } else {
                dividendUnderValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                ).length;

                dividendOverValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                ).length;

                dividendDeepValuedCount = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear20Id056) >= 200)
                ).length;

                nondividendUnderValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                ).length;

                nondividendOverValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                ).length;

                nondividendDeepValuedCount = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear20Id060) <= 90)
                ).length;

            }


            if (this.selectedExchange === "JSE") {
                if (this.selectedTimePeriod === "5") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedJseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpJseCriteria).length;
                } else if (this.selectedTimePeriod === "10") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedJseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpJseCriteria).length;

                } else if (this.selectedTimePeriod === "15") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedJseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpJseCriteria).length;

                } else {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria).length;

                }

            } else if (this.selectedExchange === "LSE") {
                if (this.selectedTimePeriod === "5") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedLseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpLseCriteria).length;

                } else if (this.selectedTimePeriod === "10") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedLseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpLseCriteria).length;

                } else if (this.selectedTimePeriod === "15") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedLseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpLseCriteria).length;

                } else {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpLseCriteria).length;

                }

            } else { // NYSE, NASDAQ, TO
                if (this.selectedTimePeriod === "5") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedNyseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpNyseCriteria).length;

                } else if (this.selectedTimePeriod === "10") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedNyseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpNyseCriteria).length;

                } else if (this.selectedTimePeriod === "15") {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedNyseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpNyseCriteria).length;

                } else {
                    topRankedCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria).length;
                    runnersUpCount = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpNyseCriteria).length;

                }

            }

            return {
                topRankedCount,
                runnersUpCount,
                dividendUnderValuedCount,
                dividendOverValuedCount,
                dividendDeepValuedCount,
                nondividendUnderValuedCount,
                nondividendOverValuedCount,
                nondividendDeepValuedCount
            };
        },
        async onCustomFilterChange() {
            console.log("[Overview][onCustomFilterChange] this.selectedCustomFilter = ", this.selectedCustomFilter);

            this.activeTab = 8;
            this.customFilterStockData = {};

            if (this.selectedCustomFilter === "custom1") {
                console.log("[Overview][onCustomFilterChange] Processing this.selectedCustomFilter = ", this.selectedCustomFilter);

                this.customFilterStockData.siCriteriaYear20Id128 = 6;
                this.customFilterStockData.undervaluedVsOvervaluedStatusYear20Id135 = 'U';
                this.customFilterStockData.codeId129 = 'C';
            } else if (this.selectedCustomFilter === "custom2") {
                console.log("[Overview][onCustomFilterChange] Processing this.selectedCustomFilter = ", this.selectedCustomFilter);

                this.customFilterStockData.siCriteriaYear20Id128 = 5;
                this.customFilterStockData.undervaluedVsOvervaluedStatusYear20Id135 = 'U';
                this.customFilterStockData.codeId129 = 'R';
            }

            console.log("[Overview][onCustomFilterChange] this.customFilterStockData = ", this.customFilterStockData);

            try {
                const [stockDataInfo] = await Promise.all([
                    StockDataService.processCustomFilterSearchForStockData(this.customFilterStockData)
                ]);

                this.customFilterSearchStockDataList = stockDataInfo.data;
                console.log("[Overview][onCustomFilterChange] this.customFilterSearchStockDataList = ", this.customFilterSearchStockDataList);

                this.loading = false;

            } catch (e) {
                console.log("[Overview][onCustomFilterChange] error = ", e);
                this.stockData = {};
            }

        },
        async onFilterChange() {
            console.log("[Overview][onFilterChange] this.selectedStandardFilter = ", this.selectedStandardFilter);

            let stockCounts = this.getStockCounts();
            console.log("stockCounts.topRankedCount = ", stockCounts.topRankedCount);
            console.log("stockCounts.runnersUpCount = ", stockCounts.runnersUpCount);
            console.log("stockCounts.dividendUnderValuedCount = ", stockCounts.dividendUnderValuedCount);
            console.log("stockCounts.dividendOverValuedCount = ", stockCounts.dividendOverValuedCount);
            console.log("stockCounts.dividendDeepValuedCount = ", stockCounts.dividendDeepValuedCount);
            console.log("stockCounts.nondividendUnderValuedCount = ", stockCounts.nondividendUnderValuedCount);
            console.log("stockCounts.nondividendOverValuedCount = ", stockCounts.nondividendOverValuedCount);
            console.log("stockCounts.nondividendDeepValuedCount = ", stockCounts.nondividendDeepValuedCount);

            if (this.selectedStandardFilter === "runnersUp") {

                this.selectedFormat = "Complete";

                if (this.selectedExchange === "JSE") {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria);
                } else if (this.selectedExchange === "LSE") {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpLseCriteria);
                } else {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpNyseCriteria);
                }

            } else if (this.selectedStandardFilter === "dividendStocksUnderValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                );

            } else if (this.selectedStandardFilter === "dividendStocksOverValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                );

            } else if (this.selectedStandardFilter === "dividendStocksDeepValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    (stock.afdPreviousId005 === -888888 ||
                        stock.afdPreviousId005 === -777777 ||
                        stock.afdPreviousId005 >= 0) &&
                    ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear20Id056) >= 200)
                );

            } else if (this.selectedStandardFilter === "nondividendStocksUnderValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                );

            } else if (this.selectedStandardFilter === "nondividendStocksOverValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                );

            } else if (this.selectedStandardFilter === "nondividendStocksDeepValued") {

                this.selectedFormat = "Complete";

                this.stockData = this.originalStockData.filter(stock =>
                    stock.afdPreviousId005 != -999999 &&
                    ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear20Id060) <= 90)
                );

            } else {
                this.selectedFormat = "Compact";

                if (this.selectedExchange === "JSE") {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                } else if (this.selectedExchange === "LSE") {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                } else {
                    this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                }
            }

            this.standardFilters = [
                { name: `Top Ranked (${stockCounts.topRankedCount})`, code: 'topRanked' },
                { name: `Runners-Up (${stockCounts.runnersUpCount})`, code: 'runnersUp' },
                {
                    name: `Dividend Stocks Under-valued (${stockCounts.dividendUnderValuedCount})`,
                    code: 'dividendStocksUnderValued'
                },
                {
                    name: `Dividend Stocks Over-valued (${stockCounts.dividendOverValuedCount})`,
                    code: 'dividendStocksOverValued'
                },
                {
                    name: `Dividend Stocks Deep-valued (${stockCounts.dividendDeepValuedCount})`,
                    code: 'dividendStocksDeepValued'
                },
                {
                    name: `Non Dividend Stocks Under-valued (${stockCounts.nondividendUnderValuedCount})`,
                    code: 'nondividendStocksUnderValued'
                },
                {
                    name: `Non Dividend Stocks Over-valued (${stockCounts.nondividendOverValuedCount})`,
                    code: 'nondividendStocksOverValued'
                },
                {
                    name: `Non Dividend Stocks Deep-valued (${stockCounts.nondividendDeepValuedCount})`,
                    code: 'nondividendStocksDeepValued'
                }
            ];

        },
        async onTimePeriodChange() {
            console.log("[Overview][onTimePeriodChange] this.selectedTimePeriod = ", this.selectedTimePeriod);

            let stockCounts = this.getStockCounts();
            console.log("stockCounts.topRankedCount = ", stockCounts.topRankedCount);
            console.log("stockCounts.runnersUpCount = ", stockCounts.runnersUpCount);
            console.log("stockCounts.dividendUnderValuedCount = ", stockCounts.dividendUnderValuedCount);
            console.log("stockCounts.dividendOverValuedCount = ", stockCounts.dividendOverValuedCount);
            console.log("stockCounts.dividendDeepValuedCount = ", stockCounts.dividendDeepValuedCount);
            console.log("stockCounts.nondividendUnderValuedCount = ", stockCounts.nondividendUnderValuedCount);
            console.log("stockCounts.nondividendOverValuedCount = ", stockCounts.nondividendOverValuedCount);
            console.log("stockCounts.nondividendDeepValuedCount = ", stockCounts.nondividendDeepValuedCount);

            if (this.selectedStandardFilter === "runnersUp") {

                this.selectedFormat = "Complete";

                if (this.selectedExchange === "JSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpJseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpJseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpJseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria);
                    }

                } else if (this.selectedExchange === "LSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpLseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpLseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpLseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpLseCriteria);
                    }

                } else {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.runnersUpNyseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.runnersUpNyseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.runnersUpNyseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpNyseCriteria);
                    }

                }

            } else if (this.selectedStandardFilter === "dividendStocksUnderValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear5Id132 === 'U'
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear10Id133 === 'U'
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear15Id134 === 'U'
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                    );
                }

            } else if (this.selectedStandardFilter === "dividendStocksOverValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear5Id132 === 'O'
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear10Id133 === 'O'
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear15Id134 === 'O'
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                    );

                }

            } else if (this.selectedStandardFilter === "dividendStocksDeepValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear5Id053) >= 200)
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear10Id054) >= 200)
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear15Id055) >= 200)
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        (stock.afdPreviousId005 === -888888 ||
                            stock.afdPreviousId005 === -777777 ||
                            stock.afdPreviousId005 >= 0) &&
                        ((stock.currentDividendYieldId050 - stock.diffDyCurrentVsAverageYear20Id056) >= 200)
                    );

                }

            } else if (this.selectedStandardFilter === "nondividendStocksUnderValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear5Id132 === 'U'
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear10Id133 === 'U'
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear15Id134 === 'U'
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear20Id135 === 'U'
                    );

                }

            } else if (this.selectedStandardFilter === "nondividendStocksOverValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear5Id132 === 'O'
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear10Id133 === 'O'
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear15Id134 === 'O'
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        stock.undervaluedVsOvervaluedStatusYear20Id135 === 'O'
                    );

                }

            } else if (this.selectedStandardFilter === "nondividendStocksDeepValued") {

                this.selectedFormat = "Complete";

                if (this.selectedTimePeriod === "5") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear5Id057) <= 90)
                    );

                } else if (this.selectedTimePeriod === "10") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear10Id058) <= 90)
                    );

                } else if (this.selectedTimePeriod === "15") {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear15Id059) <= 90)
                    );

                } else {
                    this.stockData = this.originalStockData.filter(stock =>
                        stock.afdPreviousId005 != -999999 &&
                        ((stock.peRatioId104 - stock.diffPeCurrentVsAverageYear20Id060) <= 90)
                    );

                }

            } else {
                this.selectedFormat = "Compact";

                if (this.selectedExchange === "JSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedJseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                    }

                } else if (this.selectedExchange === "LSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedLseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                    }

                } else {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedNyseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                    }

                }
            }

            this.standardFilters = [
                { name: `Top Ranked (${stockCounts.topRankedCount})`, code: 'topRanked' },
                { name: `Runners-Up (${stockCounts.runnersUpCount})`, code: 'runnersUp' },
                {
                    name: `Dividend Stocks Under-valued (${stockCounts.dividendUnderValuedCount})`,
                    code: 'dividendStocksUnderValued'
                },
                {
                    name: `Dividend Stocks Over-valued (${stockCounts.dividendOverValuedCount})`,
                    code: 'dividendStocksOverValued'
                },
                {
                    name: `Dividend Stocks Deep-valued (${stockCounts.dividendDeepValuedCount})`,
                    code: 'dividendStocksDeepValued'
                },
                {
                    name: `Non Dividend Stocks Under-valued (${stockCounts.nondividendUnderValuedCount})`,
                    code: 'nondividendStocksUnderValued'
                },
                {
                    name: `Non Dividend Stocks Over-valued (${stockCounts.nondividendOverValuedCount})`,
                    code: 'nondividendStocksOverValued'
                },
                {
                    name: `Non Dividend Stocks Deep-valued (${stockCounts.nondividendDeepValuedCount})`,
                    code: 'nondividendStocksDeepValued'
                }
            ];

        },
        async onFormatChange() {
            console.log("[Overview][onFilterChange] this.selectedFormat = ", this.selectedFormat);
        },
        async onStockDataTimePeriodChange() {
            console.log("[Overview][onStockDataTimePeriodChange] Got here.");

            const timePeriodMap = {
                "5": -5,
                "10": -10,
                "15": -15,
                "20": -20,
                "Maximum": -25
            };

            const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

            const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

            const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

            console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

            let selectedOption = "dividendPerShare";
            let selectedLabel = "Dividends Per Share";

            if (this.selectedStockDataStockHistoryOption === "EPS") {
                selectedOption = "eps";
                selectedLabel = "EPS";
            } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                selectedOption = "lowSharePrice";
                selectedLabel = "Low Price";

            } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                selectedOption = "highSharePrice";
                selectedLabel = "High Price";

            } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                selectedOption = "averageSharePrice";
                selectedLabel = "Average Price";

            } else {
                selectedOption = "dividendPerShare";
                selectedLabel = "Dividends Per Share";
            }

            console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
            console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

            if (selectedOption) {
                // Set up lineData with the appropriate label and data based on the selected option code
                this.lineData = {
                    labels: recentYears.map(item => item.year),
                    datasets: [
                        {
                            label: selectedLabel, // Use the name from the selected option
                            data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                            // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                            fill: false,
                            borderColor: '#42A5F5',
                            tension: 0.4
                        }
                    ]
                };
            } else {
                console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
            }

            this.lineOptions = {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top'
                    }
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Years'
                        }
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Value'
                        }
                    }
                }
            };
        },
        async onStockDataStockHistoryOptionChange() {
            console.log("[Overview][onStockDataStockHistoryOptionChange] Got here.");

            const timePeriodMap = {
                "5": -5,
                "10": -10,
                "15": -15,
                "20": -20,
                "Maximum": -25
            };

            const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

            const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

            const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

            console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

            let selectedOption = "dividendPerShare";
            let selectedLabel = "Dividends Per Share";

            if (this.selectedStockDataStockHistoryOption === "EPS") {
                selectedOption = "eps";
                selectedLabel = "EPS";
            } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                selectedOption = "lowSharePrice";
                selectedLabel = "Low Price";

            } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                selectedOption = "highSharePrice";
                selectedLabel = "High Price";

            } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                selectedOption = "averageSharePrice";
                selectedLabel = "Average Price";

            } else {
                selectedOption = "dividendPerShare";
                selectedLabel = "Dividends Per Share";
            }

            console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
            console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

            if (selectedOption) {
                // Set up lineData with the appropriate label and data based on the selected option code
                this.lineData = {
                    labels: recentYears.map(item => item.year),
                    datasets: [
                        {
                            label: selectedLabel, // Use the name from the selected option
                            data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                            // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                            fill: false,
                            borderColor: '#42A5F5',
                            tension: 0.4
                        }
                    ]
                };
            } else {
                console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
            }

            this.lineOptions = {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top'
                    }
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Years'
                        }
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Value'
                        }
                    }
                }
            };
        },
        async onExchangeChange() {
            console.log("[Overview][onExchangeChange] this.selectedExchange = ", this.selectedExchange);
            this.selectedFormat = "Compact";
            this.selectedStandardFilter = "topRanked";
            this.selectedTimePeriod = "20";

            const [stockDataInfo] = await Promise.all([
                StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S')
            ]);

            this.stockData = stockDataInfo.data;
            this.originalStockData = stockDataInfo.data;

            this.getDividendTrap();

            let stockCounts = this.getStockCounts();
            console.log("stockCounts.topRankedCount = ", stockCounts.topRankedCount);
            console.log("stockCounts.runnersUpCount = ", stockCounts.runnersUpCount);
            console.log("stockCounts.dividendUnderValuedCount = ", stockCounts.dividendUnderValuedCount);
            console.log("stockCounts.dividendOverValuedCount = ", stockCounts.dividendOverValuedCount);
            console.log("stockCounts.dividendDeepValuedCount = ", stockCounts.dividendDeepValuedCount);
            console.log("stockCounts.nondividendUnderValuedCount = ", stockCounts.nondividendUnderValuedCount);
            console.log("stockCounts.nondividendOverValuedCount = ", stockCounts.nondividendOverValuedCount);
            console.log("stockCounts.nondividendDeepValuedCount = ", stockCounts.nondividendDeepValuedCount);

            if (this.selectedExchange === "JSE") {
                this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
            } else if (this.selectedExchange === "LSE") {
                this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
            } else {
                this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
            }

            this.standardFilters = [
                { name: `Top Ranked (${stockCounts.topRankedCount})`, code: 'topRanked' },
                { name: `Runners-Up (${stockCounts.runnersUpCount})`, code: 'runnersUp' },
                {
                    name: `Dividend Stocks Under-valued (${stockCounts.dividendUnderValuedCount})`,
                    code: 'dividendStocksUnderValued'
                },
                {
                    name: `Dividend Stocks Over-valued (${stockCounts.dividendOverValuedCount})`,
                    code: 'dividendStocksOverValued'
                },
                {
                    name: `Dividend Stocks Deep-valued (${stockCounts.dividendDeepValuedCount})`,
                    code: 'dividendStocksDeepValued'
                },
                {
                    name: `Non Dividend Stocks Under-valued (${stockCounts.nondividendUnderValuedCount})`,
                    code: 'nondividendStocksUnderValued'
                },
                {
                    name: `Non Dividend Stocks Over-valued (${stockCounts.nondividendOverValuedCount})`,
                    code: 'nondividendStocksOverValued'
                },
                {
                    name: `Non Dividend Stocks Deep-valued (${stockCounts.nondividendDeepValuedCount})`,
                    code: 'nondividendStocksDeepValued'
                }
            ];

        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatString(value) {
            if (value) {
                const formattedValue = String(value).substring(0, 50);
                return formattedValue;
            } else {
                return '';
            }
        },
        async callStockHistory(stock) {

            this.activeTab = 5;

            try {
                const stockHistoryData = await StockHistoryService.getStockHistory(stock.exchange, stock.code)
                this.stockHistory = stockHistoryData.data;
                console.log("[Applications][mounted] this.stocks = ", this.stocks);

                this.loading = false;

            } catch (e) {
                console.log("[" + name + "][callStockHistory] error = ", e);
                this.stockHistory = [];
            }

        },
        async callStockData(stock) {

            this.activeTab = 6;

            try {
                const stockDataInfo = await StockDataService.getStockDataForExchangeAndCode(stock.exchange, stock.code)
                this.stockData = stockDataInfo.data;
                console.log("[Applications][mounted] this.stockData = ", this.stockData);

                this.loading = false;

            } catch (e) {
                console.log("[" + name + "][callStockHistory] error = ", e);
                this.stockData = {};
            }

        },
        async processAdvancedSearch() {

            this.activeTab = 7;

            if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -1) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 10;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 14;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -2) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 15;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 24;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -3) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 25;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 49;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -4) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 50;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 200;
            } else {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
                this.advancedSearchStockData.yearsDividendIncreasesId047End = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
            }

            console.log("[Overview][processAdvancedSearch] this.advancedSearchStockData = ", this.advancedSearchStockData);

            try {
                const [stockDataInfo] = await Promise.all([
                    StockDataService.processAdvancedSearchForStockData(this.advancedSearchStockData)
                ]);

                this.advancedSearchStockDataList = stockDataInfo.data;
                console.log("[Overview][processAdvancedSearch] this.advancedSearchStockDataList = ", this.advancedSearchStockDataList);

                this.loading = false;

            } catch (e) {
                console.log("[Overview][processAdvancedSearch] error = ", e);
                this.stockData = {};
            }

        }

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.highlight {
    background-color: #7cd9d1;
    /* Example: light red */
    color: black;
    /* Text color */
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-P {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-W {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-U {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-S {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-F {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-M {
        background: #FFD8B2;
        color: #805B36;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-C {
        background: #d9b78a;
        color: #b94f03;
    }

}
</style>
